<template>
  <div class="shipment-invoice-loading flex flex-column flex-gap-1">
    <Skeleton height="2rem" />
    <div class="flex flex-gap-1">
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
    </div>
    <div class="flex flex-gap-1">
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
      <Skeleton height="2rem" width="25%" />
    </div>
    <div class="flex flex-gap-1">
      <Skeleton height="2rem" width="66%" />
      <Skeleton height="2rem" width="33%" />
    </div>
    <div class="flex flex-gap-1">
      <Skeleton height="2rem" width="66%" />
      <Skeleton height="2rem" width="33%" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Skeleton from 'primevue/skeleton';
</script>
